import './style.scss';
import React, { useState } from 'react';
import { FindMySizeDropdowns } from './FIndMySizeDropdowns';
import { FMSModalState, setSizeResult } from './state';
import { sizeChartData } from './utils';
import { observer } from 'mobx-react-lite';
import AloModal from '../YogaUI/alo-ui/AloModal';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const brasData: Record<string, any> = sizeChartData.women.bras;

let FindMySizeModal = () => {
  const [shouldShowResult, setShouldShowResult] = useState(false);

  const showResult = () => {
    setShouldShowResult(true);
  };

  return (
    <AloModal
      wrapperClass="fms-modal"
      closeElement={shouldShowResult ? '[data-close="true"]' : undefined}
      trigger={
        <button tabIndex={0} type="button" className={`fms-modal-trigger button-as-link body-text-link`}>
          <span>Find My Size</span>
        </button>
      }
      showCloseButton={false}
    >
      {shouldShowResult && FMSModalState.sizeResult ? (
        <>
          <h2 className="modal-title">we recommend</h2>
          <h3 className={`size-result h3 uppercase`}>{FMSModalState.sizeResult}</h3>
          <button
            data-close
            className="main-button cta white center continue-shopping"
            onClick={() => {
              setShouldShowResult(false);
            }}
          >
            Continue shopping
          </button>
          <span
            role="button"
            className="body go-back"
            onClick={() => {
              setShouldShowResult(false);
            }}
          >
            Go Back
          </span>
        </>
      ) : (
        <>
          <h2 className="modal-title">select your size</h2>
          <FindMySizeDropdowns />
          <button
            className={`main-button cta white center`}
            disabled={!FMSModalState.cup || !FMSModalState.bust}
            onClick={() => {
              if (FMSModalState.cup && FMSModalState.bust) {
                setSizeResult(brasData[FMSModalState.cup][FMSModalState.bust]);
              }
              showResult();
            }}
          >
            Find My Size
          </button>
        </>
      )}
    </AloModal>
  );
};

FindMySizeModal = observer(FindMySizeModal);
export { FindMySizeModal };
